<template>
  <modal
    v-if="$login.can('alerts.view')"
    :classes="['v--modal', 'vue-dialog', 'alerts-modal']"
    :pivot-y="0.3"
    :adaptive="true"
    :scrollable="true"
    height="auto"
    width="460"
    name="alerts"
  >
    <div class="p-4">
      <modal-title>
        Alerts
      </modal-title>

      <vue-good-table
        v-if="alerts.length > 0"
        :rows="alerts"
        :columns="tableColumns"
        @on-row-click="({row}) => goToAlert(row)"
        styleClass="vgt-table"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'status'">
            <span
              v-if="props.row.sent_at"
              class="text-success"
            >
              &#x25cf;
              Sent
              <span v-date="{ date: props.row.sent_at, timeAgo: true }" />
            </span>
            <span
              v-else
              class="text-warning"
            >
              &#x25cf;
              Sending
              <span v-date="{ date: props.row.send_at, timeAgo: true }" />
            </span>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
      </vue-good-table>

      <div
        v-else
        class="alert alert-danger"
      >
        <h4 class="alert-heading">
          Warning
        </h4>
        There are <strong>no alerts</strong> for this article yet. {{ $login.can('alerts.create') ? 'Please create one below.' : null }}
      </div>

      <button
        v-if="$login.can('alerts.create')"
        class="btn btn-primary ml-auto"
        type="button"
        @click="createAlert"
      >
        Create new alert
      </button>
    </div>
  </modal>
</template>
<script>
import ModalTitle from '@/components/ModalTitle'
import Date from '@/directives/date'

export default {
  props: {
    articleId: {
      required: false,
      type: Number,
      default: null,
    },
    newsletterId: {
      required: false,
      type: Number,
      default: null,
    },
  },

  directives: {
    Date,
  },

  components: {
    ModalTitle,
  },

  data () {
    return {
      loading: true,
      alerts: [],
      showActions: [],
      tableColumns: [
        {
          label: 'Title',
          field: 'id',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
    }
  },

  watch: {
    articleId () {
      this.getAlerts()
    },

    newsletterId () {
      this.getAlerts()
    },
  },

  mounted () {
    this.getAlerts()
  },

  methods: {
    getAlerts () {
      const url = this.articleId
        ? `/articles/${this.articleId}/alerts`
        : `/newsletters/${this.newsletterId}/alerts`

      return this.$http.get(url)
          .then((response) => {
            this.loading = false
            this.alerts = response.data.data
          })
    },

    createAlert () {
      this.$modal.hide('alerts')
      this.$nextTick(() => {
        this.$router.push({
          name: 'alerts.create',
          params: {
            id: this.articleId || this.newsletterId,
            type: this.articleId ? 'article' : 'newsletter'},
        })
      })
    },

    goToAlert (row) {
      this.$modal.hide('alerts')
      this.$nextTick(() => {
        this.$router.push({name: 'alerts.view', params: {alertId: row.id}})
      })
    },
  },
}
</script>

<style lang="scss">
.alerts-modal {
  .btn {
    margin-top: 32px;
  }
}
</style>
